import oRequest from '@/libsV2/request.js';

const URL = {
    COMM_SMS_SEND: 'comm/sms/send', //短信验证
    MEMBER_ACCESS_BINDV2: 'member/access/bindv2',//短信验证码
}
export default {
    commSmsSend(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.COMM_SMS_SEND, oData)
    },
    accessBind(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.MEMBER_ACCESS_BINDV2, oData)
    },
}
